import {Injectable} from '@angular/core';
import {CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {AutenticacaoPropostaService} from 'src/app/api/module/externo/services/proposta/autenticacao.proposta.service';

@Injectable({
  providedIn: 'root',
})
export class AuthPropostaExternaGuard implements CanActivate {
  constructor(
    private router: Router,
    private autenticacaoPropostaService: AutenticacaoPropostaService,
    private toastr: ToastrService,
  ) {}
  private readonly CHAVE_REDIRECIONAMENTO_BENEF = 'redirectAfterLoginBenef';

  canActivate(_: any, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const url = state.url;
    const proposalId = this.extrairProposalIdDaUrl(url);
    if (!proposalId) {
      this.toastr.error('ID do documento não encontrado na URL');
      return of(this.router.createUrlTree(['/']));
    }
    // Se for uma rota de beneficiário, verifica autenticação
    if (url.includes('beneficiario/visualizar')) {
      // Salva a URL atual antes de qualquer redirecionamento
      localStorage.setItem(this.CHAVE_REDIRECIONAMENTO_BENEF, url);
      return this.autenticacaoPropostaService.verificarToken().pipe(
        map(autenticado => {
          if (!autenticado) {
            return this.router.createUrlTree([`/detalhes/proposta/autenticacao/${proposalId}`], {
              queryParams: {
                tipo: 'beneficiario',
                redirect: url,
              },
            });
          }
          return true;
        }),
        catchError(() => {
          return of(
            this.router.createUrlTree([`/detalhes/proposta/autenticacao/${proposalId}`], {
              queryParams: {
                tipo: 'beneficiario',
                redirect: url,
              },
            }),
          );
        }),
      );
    }

    // Lógica existente para outras rotas
    return this.autenticacaoPropostaService.verificarToken().pipe(
      map(autenticado => {
        if (!autenticado) {
          return this.router.createUrlTree([`detalhes/proposta/autenticacao/${proposalId}`]);
        }
        return true;
      }),
      catchError(() => {
        return of(this.router.createUrlTree([`detalhes/proposta/autenticacao/${proposalId}`]));
      }),
    );
  }

  extrairProposalIdDaUrl(url: string): string | null {
    // Tenta extrair o ID da URL de beneficiário
    const beneficiarioMatch = url.match(/proposta\/documento\/beneficiario\/visualizar\/([a-f0-9\-]{36})/i);
    if (beneficiarioMatch && beneficiarioMatch[1]) {
      return beneficiarioMatch[1];
    }

    // Mantém a lógica existente para outras rotas
    // Expressão regular para capturar um UUID (formato: 898f03cd-4dcf-4375-4a11-08dd28d014d1)
    const regex = /detalhes\/proposta\/([a-f0-9\-]{36})/i; // Regex para capturar o UUID
    const match = url.match(regex);
    if (match && match[1]) {
      return match[1]; // Retorna o UUID como string
    }
    return null;
  }
}
